module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9xs8E"))).then(() => parcelRequire('6z0SB'));